import React from 'react';
import { COLOR } from '@src/styles/color';
import { Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import CycleBlurImage from '@src/assets/images/cycle-blur.png';
import { StyledTerms } from './index.style';

const Terms = ({ termsAccepted, onTermsAccepted }) => {
  const { t } = useTranslation();

  return (
    <StyledTerms>
      <img src={CycleBlurImage} alt="cycle-blue" className="cycle-blur-image" />
      <Typography variant="body-24-bold" color={COLOR.darkBldescriptionGrayue}>
        {t('confirmUseVoice')}
      </Typography>
      <div className="terms-content">
        <Checkbox
          disabled={termsAccepted}
          checked={termsAccepted}
          onChange={onTermsAccepted}
          sx={{
            color: COLOR.darkBlue,
            '&.Mui-checked': {
              color: COLOR.darkBlue,
            },
            padding: '2px',
            marginLeft: '6px',
          }}
        />
        <Typography
          variant="body-14-regular"
          color={COLOR.descriptionUpload}
          dangerouslySetInnerHTML={{ __html: t('termVerifyVoice') }}
        />
      </div>
    </StyledTerms>
  );
};

export default Terms;
